<template>
  <div class="orderList flex">
    <div v-if="oList.length <= 0">
      <div class="header">
        <a-button v-if="!isOrderPreview" type="link" @click="logout"
          >退出登录</a-button
        >
      </div>
      <div class="empty flex">
        <div>
          <img class="empty-img" src="../assets/empty.png" alt />
          <div class="tips">空空如也，快去制作一张吧</div>
        </div>
      </div>
    </div>
    <div ref="footer" class="sidebar-con" v-else>
      <div class="header">
        <a-button v-if="!isOrderPreview" type="link" @click="logout"
          >退出登录</a-button
        >
      </div>
      <div class="sroll-wrap">
        <div class="order-items" v-if="oList.length > 0">
          <div
            :class="`order-item ${selOrderNum == idx ? 'active' : ''}`"
            @click="selOrderItem(idx)"
            v-for="(item, idx) in oList"
            :key="idx"
          >
            <div class="img-wrap">
              <img :src="item.pic_url" alt />
              <div class="sel-colors" v-if="item.zip_url !== null">
                <i
                  v-for="(colItem, index) in item.colours"
                  :key="index"
                  :style="{ background: `#${colItem.s_color}` }"
                ></i>
              </div>
              <a-button
                @click="showDeleteConfirm(idx)"
                type="dashed"
                class="trash-wrap"
              >
                <img src="../assets/Trash.png" alt />
              </a-button>
            </div>
            <div :title="item.description" class="order-ruleName">
              {{ item.description }}
            </div>
            <div class="order-num">订单编号：{{ item.order_no }}</div>
          </div>
        </div>
        <div v-else>
          <img class="empty-img" src="../assets/empty.png" alt />
          <div class="tips">空空如也，快去制作一张吧</div>
        </div>
      </div>
      <div
        :class="{ footer: true }"
        :style="{ bottom: (hasScoll ? bottom : 0) + 'px' }"
      >
        <a-button class="btn">
          <a-button type="link" @click="downPic" icon="download"
            >下载选中图片</a-button
          >
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import download from "downloadjs";
import { delOrder } from "@/utils/api";
import { getCookie, delCookie } from "../utils/cookie";
export default {
  data() {
    return {
      selOrderNum: 0,
      hasScoll: false,
      bottom: 0,
    };
  },
  props: {
    toggleLoginFn: Function,
    isOrderPreview: {
      type: Boolean,
      default: false,
    },
    oList: Array,
  },
  mounted() {
    this.bottom =
      (808 - window.innerHeight || document.documentElement.clientHeight) +
      50 +
      14 +
      10;
    this.hasScoll =
      document.body.scrollHeight >
      (window.innerHeight || document.documentElement.clientHeight);
    window.onresize = () => {
      this.bottom =
        (808 - window.innerHeight || document.documentElement.clientHeight) +
        50 +
        14 +
        10 -
        this.getScrollTop();
      this.hasScoll =
        document.body.scrollHeight >
        (window.innerHeight || document.documentElement.clientHeight);
    };
    window.onscroll = () => {
      this.bottom =
        (808 - window.innerHeight || document.documentElement.clientHeight) +
        50 +
        14 +
        10 -
        this.getScrollTop();
    };
  },
  methods: {
    getScrollTop() {
      var scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }

      return scrollTop;
    },
    logout() {
      let _self = this;
      let loginType = {
        alipay: "支付宝",
        wechat: "微信",
      };
      // let loginWarName = getCookie("lq-login-type");
      // console.log(this.loginWayArr, this.loginWayidx);
      this.$confirm({
        title: `您确认退出${
          loginType[getCookie("lq-login-type")] || "登录"
        }吗？`,
        content: "",
        okText: "确认",
        okType: "danger",
        cancelText: "再想想",
        centered: true,
        onOk() {
          delCookie("lq-handlephoto-token");
          delCookie("loginWayName");
          delCookie("lq-login-type");
          if (_self.$route.query.token) {
            _self.$router.replace(_self.$route.path);
          }
          _self.toggleLoginFn(false);
        },
        onCancel() {},
      });
    },
    selOrderItem(idx) {
      this.selOrderNum = idx;
    },
    showDeleteConfirm(idx) {
      let _self = this;
      this.$confirm({
        title: "请确认您已保存好照片， 删除照片之后将无法找回，是否确认删除？",
        content: "",
        okText: "确认",
        okType: "danger",
        cancelText: "再想想",
        centered: true,
        onOk() {
          _self.delOrderItem(idx);
        },
        onCancel() {},
      });
    },
    delOrderItem(idx) {
      delOrder(this.oList[idx].order_no).then((res) => {
        if (this.$route.query.orderno) {
          this.$router.replace(this.$route.path);
        }
        this.oList.splice(idx, 1);
        this.$message.success(res);
      });
    },
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    downPic() {
      // console.log(this.selOrderNum);
      if (this.oList[this.selOrderNum].zip_url !== null) {
        window.location.href = this.oList[this.selOrderNum].zip_url;
      } else {
        this.downloadIamge(
          this.oList[this.selOrderNum].pic_url +
            `&randomNum=${this.randomNum(1, 1000)}`
        );
      }
    },
    downloadIamge(imgsrc, name = "photo") {
      let _self = this;
      const hide = this.$message.loading("下载中...", 0);
      var x = new XMLHttpRequest();
      x.open("GET", imgsrc, true);
      x.responseType = "blob";
      x.onload = function (e) {
        download(x.response, name + ".jpg", "image/jpg");
        setTimeout(hide, 500);
      };
      x.send();
    },
    // downloadIamge(imgsrc, name) {
    //   let _self = this;
    //   //下载图片地址和图片名
    //   let image = new Image();
    //   // 解决跨域 Canvas 污染问题
    //   image.setAttribute("Access-Control-Allow-Origin", "*");
    //   image.setAttribute("crossOrigin", "Anonymous");
    //   // image.crossOrigin = "Anonymous";
    //   image.src = imgsrc;
    //   image.onload = function() {
    //     let canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     let context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     let hide = _self.$message.loading("下载中..", 0);
    //     setTimeout(hide, 4000);
    //     setTimeout(_ => {
    //       let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //       let a = document.createElement("a"); // 生成一个a元素
    //       let event = new MouseEvent("click"); // 创建一个单击事件
    //       a.download = name || "photo"; // 设置图片名称
    //       a.href = url; // 将生成的URL设置为a.href属性
    //       a.dispatchEvent(event); // 触发a的单击事件
    //     }, 4000);
    //   };
    // }
  },
};
</script>
<style scoped>
.orderList {
  width: 100%;
  height: 100%;
}
.orderList > div {
  width: 100%;
  height: 100%;
}
.orderList .empty {
  height: calc(100% - 56px);
}
.sidebar-con {
  height: 100%;
  position: relative;
  padding-bottom: 56px;
  overflow: hidden;
}
.sroll-wrap {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  width: calc(100% + 17px);
  padding-right: 17px;
  padding-bottom: 80px;
}
.img-wrap {
  margin: 0 16px;
  margin-bottom: 16px;
  position: relative;
  border: 2px solid #ffffff;
}
.img-wrap img {
  /* max-width: 100%; */
  width: 100%;
}
.img-wrap .sel-colors {
  width: 100%;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}
.img-wrap .sel-colors i {
  width: 16px;
  height: 16px;
  margin: 0 2px;
  border-radius: 4px;
  display: inline-block;
}
.img-wrap .sel-colors i.active {
  border: 1px solid rgba(67, 139, 249, 1);
}
.img-wrap .trash-wrap {
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  position: absolute;
  top: 8px;
  right: 8px;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s;
  border: none;
}
.img-wrap .trash-wrap img {
  width: 16px;
  position: absolute;
  top: calc(50% - 8px);
  left: calc(50% - 8px);
}
.order-items {
  width: 238px;
  overflow: hidden;
}
.order-item:first-child {
  padding-top: 0;
}
.order-item {
  padding-top: 24px;
  cursor: pointer;
}
.order-item.active .trash-wrap,
.order-item:hover .trash-wrap {
  opacity: 1;
  visibility: visible;
}
.order-item.active .img-wrap,
.order-item:hover .img-wrap {
  border: 2px solid #438bf9;
}

.order-num {
  color: #9c9c9c;
  font-size: 12px;
}
.order-ruleName {
  color: #303133;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 16px;
}
.header {
  width: 100%;
  height: 56px;
  /* background: #f5f7fa; */
  display: flex;
  align-items: center;
}
.fixed {
  width: 238px !important;
  position: fixed !important;
}
.footer {
  width: 100%;
  height: 56px;
  background: #f5f7fa;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header .btn,
.footer .btn {
  width: 206px;
  height: 40px;
}
</style>